<template>
    <div>
        <div class="d-flex justify-content-between align-items-center" :class="{ 'mb16': !isMobile, 'mb32': isMobile }">
            <div v-if="isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': isMobile }">
                {{ this.$t('components.service.modal.p2p.AdInfo.1') + ' ' + `#${this.offer.code}` }}
            </div>
            <div v-if="!isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>
        <div>
            <div class="bg-white rounded12 neue-roman" :class="{ 'p24': !isMobile }">
                <div class="mb16 pb16 border-b">
                    <div class="primary-grey neue-roman fsp14 lh20 mb4">
                        {{ this.$t('components.service.modal.p2p.AdInfo.2') }}
                    </div>
                    <span class="neue fsp14 lh20">{{ this.offer.external_note ? this.offer.external_note : '-' }}</span>
                </div>
                <div class="mb16 pb16 border-b">
                    <div class="primary-grey neue-roman fsp14 lh20 mb4">
                        {{ this.$t('components.service.modal.p2p.AdInfo.3') }}
                    </div>
                    <span class="neue fsp14 lh20">{{ this.offer.external_requisites ? this.offer.external_requisites : '-' }}</span>
                </div>
                <!-- Gives -->
                 <!-- v-if="this.offer.internal_curr_text" -->
                <div class="pb16 mb16 border-b">
                    <div class="d-flex flex-column gap-2 fsp14">
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="primary-grey neue-roman">
                                {{ this.$t('components.service.modal.p2p.AdInfo.4') }}
                            </span>
                            <span v-if="this.offer.internal_direction == 'Maker2taker'" class="lh20">
                                <span class="mr4">
                                    <span class="neue">{{ this.$lib.formatNumberWithSeparators(this.offer.rate_internal_count.split('.')[0]) }}</span>
                                    <span v-if="this.offer.rate_internal_count.split('.')[1]" class="fsp10 primary-grey">.{{ this.offer.rate_internal_count.split('.')[1] }}</span>
                                </span>
                                <span class="primary-grey neue">{{ this.offer.internal_curr_name }}</span>
                            </span>
                            <span v-else>
                                <span class="mr4">
                                    <span class="neue">{{ this.$lib.formatNumberWithSeparators(this.offer.rate_external_count.split('.')[0]) }}</span>
                                    <span v-if="this.offer.rate_external_count.split('.')[1]" class="fsp10 primary-grey">.{{ this.offer.rate_external_count.split('.')[1] }}</span>
                                </span>
                                <span class="primary-grey neue">{{ this.offer.external_curr_measurement }}</span>
                            </span>
                        </div>
                        <!-- Receives -->
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="primary-grey neue-roman">
                                {{ this.$t('components.service.modal.p2p.AdInfo.5') }}
                            </span>
                            <span v-if="this.offer.internal_direction == 'Maker2taker'">
                                <span class="mr4">
                                    <span class="neue">{{ this.$lib.formatNumberWithSeparators(this.offer.rate_external_count.split('.')[0]) }}</span>
                                    <span v-if="this.offer.rate_external_count.split('.')[1]" class="fsp10 primary-grey">.{{ this.offer.rate_external_count.split('.')[1] }}</span>
                                </span>
                                <span class="primary-grey neue">{{ this.offer.external_curr_measurement }}</span>
                            </span>
                            <span v-else>
                                <span class="mr4">
                                    <span class="neue">{{ this.$lib.formatNumberWithSeparators(this.offer.rate_internal_count.split('.')[0]) }}</span>
                                    <span v-if="this.offer.rate_internal_count.split('.')[1]" class="fsp10 primary-grey">.{{ this.offer.rate_internal_count.split('.')[1] }}</span>
                                </span>
                                <span class="primary-grey neue">{{ this.offer.internal_curr_name }}</span>
                            </span>
                        </div>
                        <div class="d-flex gap-3 justify-content-between align-items-center">
                            <div class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.6') }}</div>
                            <div>
                                <span class="mr4">
                                    <span>
                                        <span class="neue">{{ this.$lib.formatNumberWithSeparators(this.offer.internal_min.split('.')[0]) }}</span>
                                        <span v-if="this.offer.internal_min.split('.')[1]" class="fsp10 primary-grey">.{{ this.offer.internal_min.split('.')[1] }}</span>
                                    </span>
                                    -
                                    <span>
                                        <span class="neue">{{ this.$lib.formatNumberWithSeparators(this.offer.internal_max.split('.')[0]) }}</span>
                                        <span v-if="this.offer.internal_max.split('.')[1]" class="fsp10 primary-grey">.{{ this.offer.internal_max.split('.')[1] }}</span>
                                    </span>
                                </span>
                                <span class="primary-grey neue">{{ this.offer.internal_curr_name }}</span>
                            </div>
                        </div>
                        <div v-if="this.offer.internal_direction == 'Maker2taker'" class="d-flex gap-3 justify-content-between align-items-center">
                            <div class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.7') }}</div>
                            <div class="neue">
                                <span class="mr4">
                                    <span class="neue">{{ this.$lib.formatNumberWithSeparators(this.offer.account_balance.split('.')[0]) }}</span>
                                    <span v-if="this.offer.account_balance.split('.')[1]" class="fsp10 primary-grey">.{{ this.offer.account_balance.split('.')[1] }}</span>
                                </span>
                                <span class="primary-grey neue">
                                    {{ this.offer.internal_direction == 'Maker2taker' ? this.offer.internal_curr_name : this.offer.external_curr_name }}
                                </span>
                            </div>
                        </div>
                        <div v-if="this.offer.timeoutText" class="d-flex gap-3 fsp14 lh20 justify-content-between align-items-center" >
                            <span class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.8') }}</span>
                            <div class="d-flex align-items-center">
                                <Icon name="clock" class="c16 mr4" :active="false" />
                                <span class="neue">{{ this.offer.timeoutText }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column gap-2 fsp14">
                    <div v-if="this.offer.hasOwnProperty('active')" class="d-flex justify-content-between align-items-center">
                        <span class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.10') }}</span>
                        <span>
                            <Icon v-if="this.offer.active == 1" name="check-green" class="c20" />
                            <Icon v-else name="circle-x" class="c20" />
                        </span>
                    </div>
                    <div v-if="this.offer.hasOwnProperty('only_for_verified')" class="d-flex justify-content-between align-items-center">
                        <span class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.15') }}</span>
                        <span>
                            <Icon v-if="this.offer.only_for_verified == 1" name="check-green" class="c20" />
                            <Icon v-else name="circle-x" class="c20" />
                        </span>
                    </div>
                    <div v-if="this.offer.hasOwnProperty('only_by_link')" class="d-flex justify-content-between gap-3 align-items-center">
                        <span class="primary-grey neue-roman text-nowrap">{{ this.$t('components.service.modal.p2p.AdInfo.11') }}</span>
                        <span class="d-flex align-items-center justify-content-end">
                            <span class="d-grid col-9">
                                <router-link :to="`/p2p/offers?offerCode=${this.offer.code}`" target="_blank" class="text-truncate text-decoration-underline menu-bg neue">{{ getOfferURL() }}</router-link>
                            </span>
                            <Icon name="copy" class="c16 pointer" @click="this.$lib.copyTextS(getOfferURL(), this.$store)" />
                        </span>
                    </div>
                    <div v-if="this.offer.maker_uid" class="d-flex align-items-center justify-content-between gap-3">
                        <div class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.12') }}</div>
                        <div class="d-flex align-items-center">
                            <span class="mr4 neue">{{ this.offer.maker_uid }}</span>
                            <Icon name="copy" class="c16 pointer" @click="this.$lib.copyTextS(this.offer.maker_uid, this.$store)" />
                        </div>
                    </div>
                    <div v-if="this.offer.maker_keyt" class="d-flex align-items-center justify-content-between gap-3" >
                        <div class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.13') }}</div>
                        <div class="d-flex align-items-center">
                            <div class="mr4 neue">{{ this.offer.maker_keyt }}</div>
                            <Icon name="copy" class="c16 pointer" @click="this.$lib.copyTextS(this.offer.maker_keyt, this.$store)" />
                        </div>
                    </div>
                    <div v-if="this.offer.dt_create" class="d-flex align-items-center justify-content-between gap-3">
                        <span class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.14') }}</span>
                        <span class="neue">{{ this.formatDate(this.offer.dt_create) }}</span>
                    </div>
                    <div v-if="this.offer.dt_start" class="d-flex align-items-center justify-content-between gap-3">
                        <span class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.18') }}</span>
                        <span class="neue">{{ this.formatDate(this.offer.dt_start) }}</span>
                    </div>
                    <div v-if="this.offer.dt_end" class="d-flex align-items-center justify-content-between gap-3">
                        <span class="primary-grey neue-roman">{{ this.$t('components.service.modal.p2p.AdInfo.19') }}</span>
                        <span class="neue">{{ this.formatDate(this.offer.dt_end) }}</span>
                    </div>
                </div>    
            </div>
        </div>
    </div>
</template>
<script>
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';

export default {
    components: { 
        Tooltip,
        Icon
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            offer: this.$store.state.modal.content.offer,
            pageTitle: '',
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        formatDate(date) {
            return date.split(' ')[0].split('-').reverse().join('.') + ' ' + date.split(' ')[1];
        },
        getOfferURL() {
            return `${window.location.origin}/p2p/offers?offerCode=${this.offer.code}`;
        },
        convertTimeout(totalMinutes) {
            const minutesInHour = 60;
            const minutesInDay = 1440; // 24 * 60

            const days = Math.floor(totalMinutes / minutesInDay);
            const hours = Math.floor((totalMinutes % minutesInDay) / minutesInHour);
            const minutes = totalMinutes % minutesInHour;

            return {
                days: days,
                hours: hours,
                minutes: minutes
            };
        },
        goBack() {
            this.$router.push('/p2p/offers');
        },
        getCurrs() {
            // DELTA: disabled
            // this.axios.post('GetlistExterlanTypes').then(res => {
            //     let currList = res.data.body.curr_lists;
            //     let extList = res.data.body.external_types.tables[0].colvalues;
            //
            //     let internalCurr = currList.find(item => item.code == this.offer.internal_curr);
            //     let externalCurr = extList.find(item => item.code == this.offer.external_type);
            //
            //     console.log('getCurrs', internalCurr);
            //     if (internalCurr && internalCurr.small_name) {
            //         this.offer.internal_curr_name = internalCurr.small_name;
            //     }
            //     console.log('getCurrs', externalCurr);
            //     if (externalCurr && externalCurr.name) {
            //         this.offer.external_curr_name = externalCurr.name;
            //         this.offer.external_curr_measurement = externalCurr.curr_text ?
            //             externalCurr.curr_text :
            //             externalCurr.unit_abbreviation;
            //     }
            // })
        }
    },
    created() {
        this.getCurrs();
        if (this.offer.timeout) {
            const timeout = this.convertTimeout(this.offer.timeout);

            const days = timeout.days > 0 ? timeout.days + ' ' + this.$t('components.service.modal.p2p.AdInfo.16') : '';
            const hour = timeout.hours > 0 ? timeout.hours + ' ' + this.$t('components.service.modal.p2p.AdInfo.17') : '';
            const minutes = timeout.minutes > 0 ? timeout.minutes + ' ' + this.$t('components.service.modal.p2p.AdInfo.9') : '';
            this.offer.timeoutText = days + hour + minutes;
            //offer.timeoutText = days + hour + minutes;
        }
    }
}
</script>
